import { twoFactorAuthService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS, SET_ACTION_STATUS_ERROR } from '@/store/helpers';
import {
  GET_TWO_FACTOR_METHODS,
  GET_MFA_SETTINGS,
  ENABLE_MFA
} from './actionTypes';

import {
  SET_MFA_METHODS,
  SET_MFA_SETTINGS,
  ON_METHOD_STATUS_CHANGE
} from './mutationTypes';

const actions = {
  async [GET_TWO_FACTOR_METHODS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_TWO_FACTOR_METHODS });
    try {
      const response = await twoFactorAuthService.getTwoFactorMethods();

      commit(SET_MFA_METHODS, response.data);

      commit(SET_ACTION_STATUS_SUCCESS, {actionName: GET_TWO_FACTOR_METHODS });
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_TWO_FACTOR_METHODS, error: error });
    }
  },

  async [GET_MFA_SETTINGS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_MFA_SETTINGS });
    try {
      const response = await twoFactorAuthService.getMFASettings();

      if (response.status === 200) {
        commit(SET_MFA_SETTINGS, response.data);
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_MFA_SETTINGS });
      }
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_MFA_SETTINGS, error: error });
    }
  },

  async [ENABLE_MFA]({ commit }, { secretKey, code }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: ENABLE_MFA });
    try {
      const response = await twoFactorAuthService.enableMFA({
        SecretKey: secretKey,
        Code: code
      });

      if (response?.data?.code?.errors ?? false) {
        commit(SET_ACTION_STATUS_ERROR, { actionName: ENABLE_MFA, errorMessage: response.data.code.errors[0].errorMessage });    

      } else if (response.status === 200) {
        commit(ON_METHOD_STATUS_CHANGE, { type: 'MFA', status: true });
        commit(SET_ACTION_STATUS_SUCCESS, { actionName: ENABLE_MFA });
      }
    } catch (error) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: ENABLE_MFA, error: error });    
    }
  }
};

export default actions;